function removeNull(obj) {
  return Object.fromEntries(Object.entries(obj)
  // eslint-disable-next-line no-unused-vars
  .filter(_ref => {
    let [_, value] = _ref;
    return value !== null && value !== undefined;
  }));
}
export default removeNull;